import { commonEnums } from '@codametrix/ui-common';
import { MenuItemType } from '../../components/select/select';

export const ALL_SERVICE_LINES: MenuItemType = {
  label: 'All Service Lines',
  value: ''
};

export const DEFAULT_SERVICE_LINE: string = commonEnums.ServiceLines.RADIOLOGY;
